import { useQuery } from "@tanstack/react-query";
import { getAtkomstStores } from "@coworker/app/src/hooks/API/core.service";
import { Store } from "../../shared/types/store";

export const useAtkomstCoreStores = () =>
  useQuery<Store[]>({
    queryKey: ["atkomstStores"],
    queryFn: getAtkomstStores,
  });
